export var statusCol = {
  '& > span': {
    marginBottom: '0.4em',
    '&:last-of-type': {
      marginBottom: 0
    }
  }
};